<app-item   [entity]="entity"
            (viewClicked)="view()"
            (updateButtonClicked)="edit()"
            [displayViewButton]="true">
    <app-workflow-task-summary [entity]="entity"></app-workflow-task-summary>
    <app-action-button buttons
                       [entity]="summary"
                       [permission]="WorkflowTaskPermission.WORKFLOW_TASK_PERMISSION_EXECUTE"
                       [service]="executeService"
                       (actionSuccessEvent)="entity = $event"
                       [buildPayload]="buildExecutePayload"
                       [color]="undefined" iconName="refresh" tooltip="Relancer" size="small"></app-action-button>
</app-item>
